import {Presenter} from '../../../Support/with_presenter';
import {CrewsService} from '../../../Network/CrewsService';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {CrewMember, FullCrew} from '../../../Models/Crew';
import {MeService} from '../../../Network/MeService';
import {Me} from '../../../Models/Me';

export class CrewMembersPresenter implements Presenter {
    public get name(): string | null {
        if (this.crew.status === 'success') {
            return this.crew.data.name;
        }
        if (this.previewName) {
            return this.previewName;
        }

        return null;
    }

    public get isSubscriptionOwner(): boolean {
        if (this.me.status === 'success') {
            return this.me.data.subscriptions.some((subscription) => subscription.crewId === this.crewId);
        }
        return false;
    }

    public get subscriptionId(): number | null {
        if (this.me.status === 'success') {
            return this.me.data.subscriptions
                .filter((subscription) => subscription.crewId === this.crewId)
                .map((subscription) => subscription.id)[0];
        }
        return null;
    }

    public crew: NetworkResult<FullCrew> = loadingResponse();
    public me: NetworkResult<Me> = loadingResponse();

    constructor(
        private crewId: number,
        private previewName: string | null,
        private crewsService: CrewsService,
        private meService: MeService,
    ) {}

    public async mount(): Promise<void> {
        const [crew, me] = await Promise.all([this.crewsService.get(this.crewId), this.meService.get()]);
        this.crew = crew;
        this.me = me;
    }

    public unmount(): void {
        /* Noop */
    }

    public async toggleCoach(member: CrewMember) {
        if (member.isCoach) {
            await this.crewsService.unmakeCoach(member.crewMembershipId);
        } else {
            await this.crewsService.makeCoach(member.crewMembershipId);
        }

        this.crew = await this.crewsService.get(this.crewId);
    }

    public async removeMember(member: CrewMember) {
        await this.crewsService.removeMember(member.crewMembershipId);
        if (member.isMe) {
            window.location.href = '/crews';
        } else {
            this.crew = await this.crewsService.get(this.crewId);
        }
    }
}
